import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Ürün kodu yazınca açıklama & kalıp kodu otomatik gelir
export default function ProductAutocomplete({ value, onChange, onPick, testid }) {
  const [q, setQ] = useState(value || "");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const search = async (text) => {
    if (!text || text.length < 1) { setOpts([]); return; }
    try {
      const r = await api.get(`/products?q=${encodeURIComponent(text)}&limit=12`);
      setOpts(r.data);
      setOpen(true);
      // Tam eşleşme varsa (tıklamadan yazılsa bile) kalıp kodu & renk otomatik dolsun
      const exact = r.data.find((p) => (p.urun_kodu || "").toLowerCase() === text.trim().toLowerCase());
      if (exact && onPick) onPick(exact);
    } catch { setOpts([]); }
  };

  const pick = (p) => {
    setQ(p.urun_kodu);
    onChange(p.urun_kodu);
    onPick && onPick(p);
    setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef}>
      <input
        data-testid={testid}
        value={q}
        onChange={(e) => { setQ(e.target.value); onChange(e.target.value); search(e.target.value); }}
        onFocus={() => q && search(q)}
        placeholder="Ürün kodu yazın..."
        className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm mono focus:outline-none focus:ring-2 focus:ring-amber-600"
        autoComplete="off"
      />
      {open && opts.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto bg-white border border-zinc-300 shadow-lg rounded-sm">
          {opts.map((p) => (
            <button
              type="button"
              key={p.urun_kodu}
              onClick={() => pick(p)}
              data-testid={`product-opt-${p.urun_kodu}`}
              className="w-full text-left px-3 py-2 hover:bg-amber-50 border-b border-zinc-100 last:border-0"
            >
              <div className="mono text-sm text-zinc-900">{p.urun_kodu}</div>
              <div className="text-xs text-zinc-500 truncate">{p.aciklama || "—"} {p.kalip_kodu ? `• ${p.kalip_kodu}` : ""}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
